import React from 'react';
import { FieldConfigLabelSection } from './components/FieldConfigLabelSection';
import { FieldConfigStyleTypeSection } from './components/FieldConfigStyleTypeSection';
import { FieldConfigShowTitleSection } from './components/FieldConfigShowTitleSection';
import { FieldConfigExclusionsSection } from './components/FieldConfigExclusionsSection';

interface IntegerFieldConfigProps {
  label: string;
  onLabelChange: (value: string) => void;
  exclusionType: 'hide' | 'disable';
  onExclusionChange: (type: 'hide' | 'disable') => void;
  showTitle?: boolean;
  onShowTitleChange?: (value: boolean) => void;
  displayName?: string;
  onDisplayNameChange?: (value: string) => void;
}

const IntegerFieldConfig = ({ label, onLabelChange, exclusionType, onExclusionChange, showTitle = true, onShowTitleChange, displayName = '', onDisplayNameChange } : IntegerFieldConfigProps) => {
  return (
    <div>
      <FieldConfigLabelSection label={label} placeholderSuffix="Field label" />
      <FieldConfigStyleTypeSection fieldTypeName="Integer Field" />
      <FieldConfigShowTitleSection
        showTitle={showTitle}
        onShowTitleChange={onShowTitleChange}
        displayName={displayName}
        onDisplayNameChange={onDisplayNameChange}
      />
      <FieldConfigExclusionsSection
        exclusionType={exclusionType}
        onExclusionChange={onExclusionChange}
      />
    </div>
  );
};

export default IntegerFieldConfig;
